/**
 * Support products — client-side tab switching for category panels.
 */
(function () {
  'use strict';

  function updateTabsOverflow(tabsEl) {
    if (!tabsEl) return;
    var overflows = tabsEl.scrollWidth > tabsEl.clientWidth + 1;
    tabsEl.classList.toggle('custom-support-products__tabs--overflow', overflows);
  }

  function activateTab(root, tabId) {
    if (!root || !tabId) return;

    var tabs = root.querySelectorAll('[data-support-tab]');
    var panels = root.querySelectorAll('[data-support-panel]');

    tabs.forEach(function (tab) {
      var isActive = tab.dataset.supportTab === tabId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive && typeof tab.scrollIntoView === 'function') {
        tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    });

    panels.forEach(function (panel) {
      var isActive = panel.dataset.supportPanel === tabId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function bindHoverCards(root) {
    root.querySelectorAll('[data-support-product-card].support-product-card--has-hover').forEach(function (card) {
      var link = card.querySelector('.support-product-card__link');
      var video = card.querySelector('.support-product-card__hover-video');

      if (!link) return;

      var playVideo = function () {
        if (video && typeof video.play === 'function') {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
          }
        }
      };

      var pauseVideo = function () {
        if (video && typeof video.pause === 'function') {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {}
        }
      };

      link.addEventListener('mouseenter', function () {
        card.classList.add('is-hover');
        playVideo();
      });

      link.addEventListener('mouseleave', function () {
        card.classList.remove('is-hover');
        pauseVideo();
      });

      link.addEventListener('focusin', function () {
        card.classList.add('is-hover');
        playVideo();
      });

      link.addEventListener('focusout', function () {
        card.classList.remove('is-hover');
        pauseVideo();
      });
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.supportProductsInit === 'true') return;
    root.dataset.supportProductsInit = 'true';

    var tabsEl = root.querySelector('[data-support-tabs]');
    var defaultTab = root.dataset.defaultTab;

    if (defaultTab) {
      activateTab(root, defaultTab);
    }

    updateTabsOverflow(tabsEl);
    bindHoverCards(root);

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-support-tab]');
      if (!tab || !root.contains(tab)) return;

      event.preventDefault();
      activateTab(root, tab.dataset.supportTab);
    });

    if (tabsEl) {
      window.addEventListener('resize', function () {
        updateTabsOverflow(tabsEl);
      }, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-support-products]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector('[data-support-products]');
    if (root) initRoot(root);
  });
})();
